import NamespaceSelector from './NamespaceSelector';

export default NamespaceSelector;
